import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import {Modal, Form, FormGroup, FormControl, Col} from 'react-bootstrap';
import Select from 'react-select';
import { Map, List } from 'immutable';
import Noty from 'noty';
import classNames from 'classnames';
import { getUsers, getUsersDismiss } from '../../actions/userList';
import { retrieveWorkspaceInfo } from '../../actions/workspaces';
import Button from '../ui/Button';
import Loader from '../ui/Loader';

const mapStateToProps = state => ({
  workspaces: state.workspaces,
  userList: state.userList,
});

const mapDispatchToProps = dispatch => ({
  getUserList: () =>
    dispatch(getUsers(true)),
  onUserDismiss: () =>
    dispatch(getUsersDismiss()),
  getWorkspaceInfo: workspaceID =>
    dispatch(retrieveWorkspaceInfo(workspaceID)),
});

/* eslint react/no-find-dom-node: 0 */
/* this rule was disabled for page because it's the recommended way to get
  ref values for react bootstrap inputs (all ReactDOM.findDOMNode lines) */
class WorkspaceDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      name: '',
      description: '',
      selectedUsers: [],
      users: [],
      userList: [],
      dialogTitle: 'workspaceDialog.addChildWorkspaceHeader',
      dialogSaveButtonLabel: 'workspaceDialog.createButton',
      errMsg: '',
    };

    this.nameInput = null;
    this.descriptionInput = null;
    this.usersInput = null;

    this.onUsersChange = this.onUsersChange.bind(this);
    this.onUsersRemove = this.onUsersRemove.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onClose = this.onClose.bind(this);
    this.displayError = this.displayError.bind(this);
  }

  componentDidMount() {
    if  (this.props.isEdit) {
      this.props.getUserList()
        .then(res => {
          this.setState({ userList: res })
          return res;
        })
        .then(res =>
      this.props.getWorkspaceInfo(this.props.selectedWorkspaceData.id)
        .then((selectedUsersRes) => {
          let selectedUsers = _.map(_.filter(res,
            (user) =>
              user._.toUpperCase() !== this.props.username.toUpperCase() && _.includes(selectedUsersRes, user._)
            ), usr => ({ value: usr._, label: usr.$ ? `${usr.$.n} (${usr._})` : ''}));
          this.setState({ users: selectedUsersRes, selectedUsers });
        }));

      const existingRequest = this.props.editRequests.get(this.props.selectedWorkspaceData.id);

      this.setState({
        isSubmitting: !!existingRequest,
        name: existingRequest ? existingRequest.get('workspaceName') :
          this.props.selectedWorkspaceData.name,
        description: existingRequest ? existingRequest.get('workspaceDescription') :
          this.props.selectedWorkspaceData.description,
        selectedUsers: existingRequest ? existingRequest.get('workspaceUsers') :
          this.props.selectedWorkspaceData.users,
        users: existingRequest ? existingRequest.get('workspaceUsers') :
          this.props.selectedWorkspaceData.users,
        userList: this.props.userList,
        dialogTitle: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.editWorkspaceHeader`,
        dialogSaveButtonLabel: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.saveButton`,
      });
    } else if (this.props.selectedWorkspaceData) {
      // create workspace at non-root level
      this.setState({
        isSubmitting: false,
        name: this.props.selectedWorkspaceData.name,
        description: '',
        dialogTitle: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.addChildWorkspaceHeader`,
        dialogSaveButtonLabel: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.createButton`,
      });
    } else {
      // create workspace at root level
      this.setState({
        isSubmitting: false,
        name: '',
        description: '',
        dialogTitle: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.addWorkspaceHeader`,
        dialogSaveButtonLabel: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.createButton`,
      });
    }
  }

  onUsersChange(value) {
    this.setState({ selectedUsers: value });
  }

  onUsersRemove(e) {
    e.preventDefault();
    this.setState({ selectedUsers: [] });
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.setState({ isSubmitting: true });

    let usersValue = [];
    let removeUsersValue = [];
    if (this.props.isEdit) {
      // add users array
      usersValue = _.map(this.state.selectedUsers,
          user => (user.value ? user.value.toUpperCase() : user.toUpperCase()));

      // always add logged in user
      usersValue.push(this.props.username.toUpperCase());

      // remove users array
      removeUsersValue = _.filter(this.state.users,
          el => usersValue.indexOf(el.toUpperCase()) < 0);

      this.props.onEditSubmit(
        this.props.selectedWorkspaceData.id,
        this.state.name,
        this.state.description,
        usersValue,
        removeUsersValue
      )
        .then((res) => {
          if (res.res && res.res.s && res.res.s.s === 'T') {
            this.onClose();
          } else {
            this.displayError(res);
          }
        })
        .catch(error => this.displayError(error));
    } else {
      this.props.onCreateSubmit(
        // parent id needs to be undefined to default to root. null won't work
        this.props.selectedWorkspaceData ? this.props.selectedWorkspaceData.id : undefined,
        this.state.name,
        this.state.description,
      )
        .then((res) => {
          if (res.res && res.res.s && res.res.s.s === 'T') {
            this.onClose();
          } else {
            this.displayError(res);
          }
        })
        .catch(error => this.displayError(error));
    }
  }

  onDeleteSubmit() {
    const n = new Noty({
      theme: 'bootstrap-v4',
      timeout: false,
      type: 'info',
      text: this.props.intl.formatMessage({
        id: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.deleteWorkspace` }),
      layout: 'center',
      buttons: [
        Noty.button(this.props.intl.formatMessage({
          id: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.deleteButton` }),
          'btn btn-primary', () => {
          this.props.onDeleteSubmit(this.props.selectedWorkspaceData.id);
          n.close();
          this.onClose();
        }, { id: 'button1', 'data-status': 'ok' }),
        Noty.button(this.props.intl.formatMessage({
          id: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.cancelButton` }),
          'btn btn-error', () => {
          n.close();
        }),
      ],
    });
    n.show();
  }

  onClose() {
    this.props.onDialogClose();
  }

  displayError(errMsg) {
    this.setState({
      errMsg: (errMsg.message && errMsg.message.includes('A Lightbox with this name already exists')) ?
        `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.nameExists` :
        `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.errorOccurred`,
      isSubmitting: false,
    });
  }

  render() {
    const { intl } = this.props;
    // Set user options for share tool
    let listUsers = [];
    if (this.props.isEdit && !this.props.isHighlight) {
      const userOptions = _.map(this.state.userList, (user) => {
        if (user && user !== this.props.username) return ({ value: user._, label: user.$ ? `${user.$.n} (${user._})` : ''});
      });

      listUsers = (<Col xs="6">
          <FormGroup className="workspace-dialog__form-users">
            <label htmlFor="workspace-dialog__form-users">
              {intl.formatMessage({ id: 'workspaceDialog.shareLabel' })}
              <button
                className="workspace-dialog__form-users-remove"
                onClick={this.onUsersRemove}
              >
                <i/>
                {intl.formatMessage({ id: 'workspaceDialog.shareRemoveAll' })}
              </button>
            </label>
            <Select
              value={this.state.selectedUsers}
              isMulti
              isSearchable
              onChange={this.onUsersChange}
              name="users"
              options={userOptions}
              className="workspace-dialog__form-users-select"
              openOnFocus
              closeOnSelect
            />
          </FormGroup>
        </Col>);
    }

    return (
      <div className="workspace-dialog">
        <Modal
          show
          onHide={this.onClose}
          dialogClassName={classNames('workspace-dialog__overlay', {
            'workspace-dialog__overlay--edit': this.props.isEdit && !this.props.isHighlight,
          })}
          style={{ opacity: 1 }}
        >
          <button
            onClick={this.onClose}
            className="workspace-dialog__close-button"
          />

          <div className="workspace-dialog__form">
            <div className="workspace-dialog__form-header">
              {intl.formatMessage({ id: this.state.dialogTitle })}
              <div className="workspace-dialog__form-header-sub">
                {this.props.selectedWorkspaceData ? this.props.selectedWorkspaceData.name : ''}
              </div>
            </div>
            <Form onSubmit={this.onFormSubmit}>
              <Form.Row style={{ padding: '5px' }}>
                <Col className={classNames({ 'col-sm-6': this.props.isEdit && !this.props.isHighlight })}>
                <FormGroup className="workspace-dialog__form-name">
                  <label htmlFor="workspace-dialog__form-name">
                    {intl.formatMessage({ id: 'workspaceDialog.nameLabel' })}
                  </label>
                  <FormControl
                    type="text"
                    disabled={this.state.isSubmitting}
                    placeholder={intl.formatMessage({
                      id: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.namePlaceholder` })}
                    value={this.state.name}
                    onChange={e => this.setState({ name: e.target.value })}
                  />
                </FormGroup>
                <FormGroup className="workspace-dialog__form-description">
                  <label htmlFor="workspace-dialog__form-description">
                    {intl.formatMessage({ id: 'workspaceDialog.descriptionLabel' })}
                  </label>
                  <FormControl
                    disabled={this.state.isSubmitting}
                    as="textarea"
                    placeholder={intl.formatMessage({
                      id: `${this.props.isHighlight ? 'highlightSetDialog' : 'workspaceDialog'}.descriptionPlaceholder` })}
                    value={this.state.description}
                    onChange={e => this.setState({ description: e.target.value })}
                  />
                </FormGroup>
              </Col>
              {listUsers}
              </Form.Row>
              <Form.Row style={{ padding: '5px' }}>
              <label className="workspace-dialog__err-msg">
                {this.state.errMsg ? intl.formatMessage({ id: this.state.errMsg }) : null}
              </label>
              </Form.Row>
              <Form.Row style={{ padding: '5px' }}>
              <Button
                primary
                type="submit"
                className="workspace-dialog__save-button"
                disabled={this.state.isSubmitting}
              >
                {this.state.isSubmitting ? <Loader /> :
                  intl.formatMessage({ id: this.state.dialogSaveButtonLabel })}
              </Button>
              {
                this.props.isEdit ?
                  <Button
                    variant="danger"
                    onClick={this.onDeleteSubmit}
                    className="workspace-dialog__delete-button"
                    disabled={this.state.isSubmitting}
                  >
                    {intl.formatMessage({ id: 'workspaceDialog.deleteButton' })}
                  </Button>
                  : null}
              </Form.Row>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

WorkspaceDialog.propTypes = {
  onDialogClose: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  getUserList: PropTypes.func,
  getWorkspaceInfo: PropTypes.func,
  isEdit: PropTypes.bool,
  editRequests: PropTypes.instanceOf(Map),
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    users: PropTypes.instanceOf(List),
  }),
  username: PropTypes.string,
  userList: PropTypes.instanceOf(Map),
  isHighlight: PropTypes.bool,
};


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(WorkspaceDialog));



// WEBPACK FOOTER //
// ./src/js/components/WorkspaceDialog/index.jsx